import useBreakpoint from '@/hooks/useBreakpoint';
import { useMemo } from 'react';

/**
 * 全局响应式布局信息
 * 用户系统布局变化
 */
export default () => {
  const { isXs, isSm } = useBreakpoint();
  const isMobile = useMemo(() => isSm || isXs, [isXs, isSm]);
  return { isMobile };
};
